import type { CWILL_CUSTOM_EVENT, EventProperty } from '@channelwill/report';
import { cwreport } from './cw-report';
export function transportReport(
    // 自定义事件名集合
    event: CWILL_CUSTOM_EVENT,
    // 自定义属性名集合,按照事件名作为索引
    props: EventProperty[CWILL_CUSTOM_EVENT]
) {
    if (cwreport) {
        try {
            cwreport.report(event, props);
        } catch (error) {
            console.error('cwreport report error', error)
        }
    } else {
        console.error('cwreport is not initialized')
    }
}